import { daysBetween, todayIso } from '../../shared/data/common';

// Buses, seats and fares come live from /api/bus. Popular routes are searched by station name.
export const popularRoutes = [
  ['Hyderabad', 'Bangalore'],
  ['Bangalore', 'Chennai'],
  ['Mumbai', 'Pune'],
  ['Hyderabad', 'Vijayawada'],
  ['Chennai', 'Coimbatore'],
  ['Bangalore', 'Goa'],
];

// ID proofs operators accept, as the API names them.
export const idTypes = [
  ['Aadhaar', 'Aadhaar card'],
  ['Pan', 'PAN card'],
  ['Passport', 'Passport'],
  ['DrivingLicence', 'Driving licence'],
  ['VoterId', 'Voter ID'],
  ['RationCard', 'Ration card'],
];

/**
 * One line per cancellation rule, e.g. "24–48 hours before departure: 80% refund". Rules come
 * most hours first, and each rule's refundPercentage is what the operator refunds in that window.
 */
export function cancellationLines(rules = []) {
  return rules.map((r) => {
    const when = r.toHours == null
      ? `${r.fromHours}+ hours before departure`
      : r.fromHours > 0
        ? `${r.fromHours}–${r.toHours} hours before departure`
        : `Less than ${r.toHours} hours before departure`;
    const refund = r.refundPercentage >= 100 ? 'full refund' : r.refundPercentage > 0 ? `${r.refundPercentage}% refund` : 'no refund';
    return `${when}: ${refund}`;
  });
}

/** The refund now, from the rules, e.g. 30 for "30% refund", or null without rules. */
export function refundPercentNow(rules = [], departure, now = new Date()) {
  if (!rules.length || !departure) return null;
  const hours = (new Date(departure) - now) / 36e5;
  if (hours <= 0) return 0;
  const rule = rules.find((r) => hours >= r.fromHours && (r.toHours == null || hours < r.toHours));
  return rule ? rule.refundPercentage : 0;
}

/** Refund estimate for bookings saved without a supplier booking; live tickets are quoted by the API. */
export function busRefund(booking) {
  const days = daysBetween(todayIso(), booking.travelDate);
  if (days < 0) return { amount: 0, note: 'The journey date has passed.' };
  if (days >= 2) return { amount: Math.round(booking.fare.total * 0.9), note: '10% cancellation charge.' };
  return { amount: Math.round(booking.fare.total * 0.5), note: '50% cancellation charge within 48 hours of departure.' };
}
